import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function useDocumentTitle(
  title: string | undefined = undefined,
) {
  const { t } = useTranslation();

  const updateDocumentTitle = useCallback(
    (item: string[] | string | undefined) => {
      const allItems = [t('service.title')];

      if (item) {
        const itemsToAdd = Array.isArray(item) ? item : [item];
        allItems.unshift(...itemsToAdd);
      }

      document.title = allItems.join(' | ');
    },
    [t],
  );

  useEffect(() => {
    const newTitle = title;

    updateDocumentTitle(newTitle);
  }, [title, updateDocumentTitle]);

  return { updateDocumentTitle };
}
